import { useContext } from 'react';
import PropTypes from 'prop-types';
import { CUSTOMER_TYPE, PAYMENT_METHOD } from 'components/common/constants';
import i18nContext from 'components/i18n-context';
import { useMediaQuery } from 'services/useMediaQUery';
import { amountFormattedValue, MEDIA_QUERY } from 'services/utils';
import { ActionButton } from 'uikit/ActionButton/ActionButton';
import './TemplatesTable.scss';

const TemplatesTable = ({ templates, onUse, onRemove, onEdit }) => {
  const i18n = useContext(i18nContext);
  const isMobile = useMediaQuery(MEDIA_QUERY.MOBILE);

  if (isMobile) {
    return (
      <div className={'templates-table'}>
        {templates.map((template, index) => {
          const isCryptoCurrency = !!template?.requisites?.cryptoAddress;
          const formattedAmount = template?.amountDetails?.displayAmount || amountFormattedValue(template?.amount, 2);

          return (
            <div className={'template-item-mobile'} key={index}>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.templateName')}</div>
                <div className={'template-item-cell-content'}>{template?.templateName}</div>
              </div>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.currency')}</div>
                <div className={'template-item-cell-content'}>{template?.currency}</div>
              </div>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.recipientName')}</div>
                <div className={'template-item-cell-content'}>
                  {template?.beneficiary?.type === CUSTOMER_TYPE.INDIVIDUAL.toUpperCase()
                    ? `${template?.beneficiary?.firstName} ${template?.beneficiary?.lastName}`
                    : template?.beneficiary?.companyName}
                </div>
              </div>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.transferDetails')}</div>
                <div className={'template-item-cell-content'}>{template?.comment}</div>
              </div>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.amount')}</div>
                <div className={'template-item-cell-content'}>{formattedAmount}</div>
              </div>
              <div className={'template-item-row'}>
                <div className={'template-item-head-label'}>{i18n.getMessage('templates.table.actions')}</div>
                <div className={'template-item-actions'}>
                  <ActionButton
                    tooltipText={i18n.getMessage('templates.table.use.tooltip')}
                    iconType={'new-payment'}
                    onClick={() => onUse(template)}
                  />
                  <ActionButton
                    tooltipText={i18n.getMessage('templates.table.remove.tooltip')}
                    iconType={'remove'}
                    onClick={() => onRemove(template?.templateId)}
                  />
                  <ActionButton
                    tooltipText={i18n.getMessage('templates.table.edit.tooltip')}
                    iconType={'edit-for-approval'}
                    onClick={() => onEdit(template)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  const isCryptoTemplate = (template) =>
    template.paymentMethod === PAYMENT_METHOD.CRYPTO ||
    (template.paymentMethod === PAYMENT_METHOD.INTERNAL && !!template.requisites?.cryptoAddress);

  const getRecipientName = (template) => {
    if (!template) {
      return '';
    }

    if (isCryptoTemplate(template)) {
      return '';
    }

    return template?.beneficiary?.type === CUSTOMER_TYPE.INDIVIDUAL.toUpperCase()
      ? `${template?.beneficiary?.firstName} ${template?.beneficiary?.lastName}`
      : template?.beneficiary?.companyName;
  };

  return (
    <div className={'templates-table'}>
      <div className={'table-header'}>
        <div className={'template-name-cell'}>{i18n.getMessage('templates.table.templateName')}</div>
        <div className={'currency-cell'}>{i18n.getMessage('templates.table.currency')}</div>
        <div className={'recipient-name-cell'}>{i18n.getMessage('templates.table.recipientName')}</div>
        <div className={'purpose-cell'}>{i18n.getMessage('templates.table.transferDetails')}</div>
        <div className={'amount-cell'}>{i18n.getMessage('templates.table.amount')}</div>
        <div className={'actions-cell'}>{i18n.getMessage('templates.table.actions')}</div>
      </div>
      <div className={'table-body'}>
        {templates.map((template) => {
          const isCryptoCurrency = !!template?.requisites?.cryptoAddress;
          const formattedAmount = template?.amountDetails?.displayAmount || amountFormattedValue(template?.amount, 2);

          return (
            <div key={template?.templateId} className={'table-row'}>
              <div className={'template-name-cell'}>{template?.templateName}</div>
              <div className={'currency-cell'}>{template?.currency}</div>
              <div className={'recipient-name-cell'}>{getRecipientName(template)}</div>
              <div className={'purpose-cell'}>{template?.comment}</div>
              <div className={'amount-cell'}>{formattedAmount}</div>
              <div className={'actions-cell'}>
                <ActionButton
                  tooltipText={i18n.getMessage('templates.table.use.tooltip')}
                  iconType={'new-payment'}
                  onClick={() => onUse(template)}
                />
                <ActionButton
                  tooltipText={i18n.getMessage('templates.table.remove.tooltip')}
                  iconType={'remove'}
                  onClick={() => onRemove(template?.templateId)}
                />
                <ActionButton
                  tooltipText={i18n.getMessage('templates.table.edit.tooltip')}
                  iconType={'edit-for-approval'}
                  onClick={() => onEdit(template)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TemplatesTable.propTypes = {
  templates: PropTypes.array,
  onUse: PropTypes.func,
  onRemove: PropTypes.func,
  onEdit: PropTypes.func
};

export default TemplatesTable;
